import { v4 as uuid } from 'uuid';

import { EFormSectionType, EQuestionType, IForm } from 'modules/forms/interfaces/form.interfaces';
import { EGender } from 'interfaces/patients.interfaces';

export const generalPrescreeningForm: IForm = {
  title: 'Pre-Screening Form',
  showPatientConsent: false,
  showShareWithGPConsent: true,
  showHealthRecordAccessConsent: true,
  sections: [
    {
      uuid: 'section0',
      title: 'Pregnancy/Breastfeeding',
      showTitle: true,
      questions: [
        {
          uuid: uuid(),
          title: 'Are you pregnant, planning a pregnancy, or breastfeeding at the moment?',
          type: EQuestionType.BINARY,
          required: true,
          showAdditionalInfo: true,
          additionalInfoLabel:
            'Please provide us any additional details to assist us with your consultation',
        },
      ],
      conditions: [
        {
          type: 'customer',
          field: 'gender',
          operator: 'in',
          value: [EGender.FEMALE, EGender.NON_BINARY],
        },
      ],
    },
    {
      uuid: 'section1',
      title: 'Allergies',
      showTitle: true,
      questions: [
        {
          uuid: uuid(),
          title: 'Do you have any allergies (including medicines, foods, or vaccines)?',
          type: EQuestionType.BINARY,
          showAdditionalInfo: true,
          required: true,
          additionalInfoLabel:
            'Please provide us any additional details to assist us with your consultation',
        },
      ],
    },
    {
      uuid: 'section2',
      title: 'Previous Reactions',
      showTitle: true,
      questions: [
        {
          uuid: uuid(),
          title: 'Have you ever had a severe allergic reaction?',
          type: EQuestionType.BINARY,
          showAdditionalInfo: true,
          required: true,
          additionalInfoLabel:
            'Please provide us any additional details to assist us with your consultation',
        },
      ],
    },
    {
      uuid: 'section3',
      title: 'Current Health',
      showTitle: true,
      questions: [
        {
          uuid: uuid(),
          title: 'Are you feeling unwell or do you have a temperature today?',
          type: EQuestionType.BINARY,
          showAdditionalInfo: true,
          required: true,
          additionalInfoLabel:
            'Please provide us any additional details to assist us with your consultation',
        },
      ],
    },
    {
      uuid: 'section4',
      title: 'Mental Health',
      showTitle: true,
      questions: [
        {
          uuid: uuid(),
          title:
            'Do you have any current mental-health or emotional-wellbeing concerns such as stress, anxiety, low mood or depression that might be relevant to your care?',
          type: EQuestionType.BINARY,
          required: true,
          showAdditionalInfo: true,
          additionalInfoLabel:
            'Please provide us any additional details to assist us with your consultation',
        },
      ],
    },
    {
      uuid: 'section5',
      title: 'Existing Health Conditions',
      questions: [
        {
          uuid: uuid(),
          title: 'Please tell us if you have any of the following conditions:',
          type: EQuestionType.CHECKBOXES,
          required: true,
          hasNoneOption: true,
          options: [
            'Epilepsy or another neurological condition',
            'Heart problems, disease or previous heart surgery',
            'Asthma or other lung/breathing problems',
            'Diabetes',
            'Kidney or liver problems',
            'None of the above',
          ],
          showAdditionalInfo: true,
          additionalInfoLabel:
            'Please provide us any additional details to assist us with your consultation',
        },
      ],
    },
    {
      uuid: 'section6',
      title: 'Immune System',
      showTitle: true,
      questions: [
        {
          uuid: uuid(),
          title:
            'Do you have a weakened immune system, or take medicines that affect your immune system (such as for cancer treatments)?',
          type: EQuestionType.BINARY,
          required: true,
          showAdditionalInfo: true,
          additionalInfoLabel:
            'Please provide us any additional details to assist us with your consultation',
        },
      ],
    },
    {
      uuid: 'section7',
      title: 'Medical History',
      showTitle: true,
      questions: [
        {
          uuid: uuid(),
          title:
            'Please tell us about any ongoing health conditions, past illnesses or operations we should know about to support your care.',
          placeholder: `Example:\nHypertension - diagnosed 2020, well controlled on Lisinopril\nAppendectomy 2015 - no complications\nSeasonal asthma - uses salbutamol inhaler as needed`,
          type: EQuestionType.LONG_TEXT,
        },
      ],
    },
    {
      uuid: 'section8',
      title: 'Medications',
      showTitle: true,
      questions: [
        {
          uuid: uuid(),
          title:
            'Please list any medicines you are currently taking including prescription, over-the-counter medicines, and vitamins/supplements.',
          placeholder: `Example:\nParacetamol 500mg twice daily for headaches (started Jan 2024)\nVitamin D 1000IU daily supplement\nMetformin 500mg twice daily for diabetes`,
          type: EQuestionType.LONG_TEXT,
        },
      ],
    },
    {
      uuid: 'section9',
      title:
        'If you are completing this form as a parent, guardian, or carer on behalf of the patient, please provide your details. Otherwise select "Next" and move to the next section.',
      showTitle: true,
      questions: [
        {
          uuid: uuid(),
          title: 'Name',
          placeholder: 'Name',
          type: EQuestionType.SHORT_TEXT,
        },
        {
          uuid: uuid(),
          title: 'Relationship to Patient',
          placeholder: 'Relationship',
          type: EQuestionType.SHORT_TEXT,
        },
        {
          uuid: uuid(),
          type: EQuestionType.ADDRESS,
        },
      ],
    },
    {
      uuid: 'section10',
      title: 'Pre-Consultation Consent',
      type: EFormSectionType.SIGNATURE,
      questions: [],
    },
    {
      uuid: 'submit',
      title: 'Thank you for taking the time to complete this form.',
      questions: [],
    },
  ],
};
